import mainService from "services/mainService";

/**
 * Obtém todas as ofertas de uma bigcompany.
 * @param {number} bigcompanyPk - ID da Big company.
 * @param {number} page - Página atual
 * @param {number} pageSize - Quantidade de itens por pagina
 * @param {object} filters - Filtros aplicados ao relatorio
 *  @param {string} filters.starts_at - Data de inicio das ofertas de job
 *  @param {string} filters.ends_at - Data de fim das ofertas de job
 *  @param {string} filters.status - Status das ofertas de job
 *  @param {string} filters.units - Unidades das ofertas de job
 *
 */
export const getAllOffersBigcompany = ({
  bigcompanyPk,
  page,
  pageSize,
  filters,
}) => {
  const url = `v2/jobs/bigcompany/${bigcompanyPk}/all_offers_bigcompany/report?page=${page}&page_size=${pageSize}${filters}`;
  return mainService.get(url);
};

/**
 * Obtém o valor total das ofertas de uma bigcompany no periodo.
 * @param {number} bigcompanyPk - ID da Big company.
 * @param {number} page - Página atual
 * @param {number} pageSize - Quantidade de itens por pagina
 * @param {object} filters - Filtros aplicados ao relatorio
 *  @param {string} filters.starts_at - Data de inicio das ofertas de job
 *  @param {string} filters.ends_at - Data de fim das ofertas de job
 *  @param {string} filters.status - Status das ofertas de job
 *  @param {string} filters.units - Unidades das ofertas de job
 */
export const getTotalExpensesOffersBigcompany = ({ bigcompanyPk, filters }) => {
  const url = `v2/jobs/bigcompany/${bigcompanyPk}/all_offers_bigcompany/total_expenses?starts_at=${filters?.starts_at}&ends_at=${filters?.ends_at}&status=${filters?.status}&units=${filters?.units}`;
  return mainService.get(url);
};

/**
 * Gera o relatorio das ofertas de uma bigcompany.
 * @param {number} bigcompanyPk - ID da Big company.
 * @param {string} email - E-mail que vai ser enviado o relatorio
 * @param {object} filters - Filtros aplicados ao relatorio
 *  @param {string} filters.starts_at - Data de inicio das ofertas de job
 *  @param {string} filters.ends_at - Data de fim das ofertas de job
 *  @param {string} filters.status - Status das ofertas de job
 *  @param {string} filters.units - Unidades das ofertas de job
 */
export const generateReportAllOffersBigcompany = ({
  bigcompanyPk,
  email,
  filters,
}) => {
  const url = `v2/jobs/bigcompany/${bigcompanyPk}/all_offers_bigcompany/report`;
  return mainService.post(url, {
    email,
    ...filters,
  });
};
